// 数量选择器按钮方法
window.handleQuantity = function (action) {
    console.log('点击了 ' + action);

    var elements = document.querySelectorAll('.quantity-input');

    elements.forEach(function (element) {
        var result = parseInt(element.value);

        if (!isNaN(result)) {
            if (action === 'increment') {
                element.value = result + 1;
            } else if (action === 'decrement' && result > 1) {
                element.value = result - 1;
            }

            console.log('操作：' + action + '，新值：' + element.value);
        }
    });
}

// product-template.liquid 方法
document.addEventListener('DOMContentLoaded', function () {
    // 1. 使用事件委托处理静态和动态元素
    document.addEventListener('click', function (event) {
        // 产品导航标签切换
        if (event.target.closest('#productnav .parent')) {
            const parent = $(event.target.closest('#productnav .parent')); // 转换为jQuery对象
            parent.addClass("parentactive").siblings().removeClass("parentactive");
            
            const nameid = parent.attr("data-id");
            $(".productcontent-container").removeClass("active"); // 先移除所有active
            $(`#${nameid}`).addClass("active"); // 激活目标内容
            
            // console.log('切换标签:', nameid);
        }

        // 跳转评论标签
        else if (event.target.closest('.forreview')) {
            $("#productnav li[data-id='contab_3']").addClass("parentactive").siblings().removeClass("parentactive");
            $("#contab_3").addClass("active").show().siblings().removeClass("active").hide();
            // console.log('跳转到评论标签');
        }

        // 折叠面板（统一处理）
        else if (event.target.closest('.card__collapsible-button')) {
            const button = $(event.target.closest('.card__collapsible-button'));
            const targetId = button.closest('.card').find('.card__collapsible-content').attr('id');
            button.find('.open').toggleClass('extend');
            $(`#${targetId}`).slideToggle(500);
            // console.log('折叠面板交互:', targetId);
        }

        // 显示更多/更少
        else if (event.target.closest('.show-more, .show-more2')) {
            const button = $(event.target);
            const isShowMore = button.text().trim() === 'show more';
            const container = button.hasClass('show-more') ? '.short-desc' : '.short-desc2';

            $(`${container} ul>li:hidden`).toggle();
            button.text(isShowMore ? "show less" : "show more");
            // console.log('内容截断操作:', container, isShowMore ? '展开' : '收起');
        }
    });

    // // 2. 使用 MutationObserver 监听动态加载的内容
    // const observer = new MutationObserver(function (mutations) {
    //     mutations.forEach(function (mutation) {
    //         if (mutation.addedNodes.length) {
    //             console.log('检测到动态内容加载，重新初始化交互');
    //             initCollapsiblePanels();
    //             initShowMore();
    //         }
    //     });
    // });

    // observer.observe(document.body, {
    //     childList: true,
    //     subtree: true
    // });

    // // 初始化函数
    // function initCollapsiblePanels() {
    //     $('[id^="contab_"] .card').each(function () {
    //         const containerId = `#${$(this).closest('[id^="contab_"]').attr('id')}`;
    //         const targetId = `#${$(this).find('.card__collapsible-content').attr('id')}`;
    //         if (!$(targetId).length) return;

    //         console.log('初始化折叠面板:', containerId, '->', targetId);
    //     });
    // }

    // function initShowMore() {
    //     ['.short-desc', '.short-desc2'].forEach(selector => {
    //         const lis = $(`${selector} ul>li`).length;
    //         const maxline = 1;
    //         const max = lis > maxline ? maxline - 1 : lis - 1;

    //         if (lis === 0) {
    //             $(selector).next('.show-more, .show-more2').hide();
    //         } else {
    //             $(`${selector} ul>li:gt(${max})`).hide();
    //         }
    //         console.log('初始化内容截断:', selector, '显示', max + 1, '/', lis, '条');
    //     });
    // }

    // // 初始执行
    // initCollapsiblePanels();
    // initShowMore();
});
